import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  tabList: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 50,
    padding: '6px',
    maxHeight: 100,
    marginBottom: 32,
    listStyle: 'none',
    overflowX: 'auto',
    [theme.breakpoints.down('md')]: {
      maxHeight: 55
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: 55
    }
  },
  tabListItem: {
    display: 'block',
    flex: 1,
    padding: 0,
    margin: '0 auto',
    textAlign: 'center'
  },
  tabButton: {
    width: '100%',
    padding: '10px 20px',
    background: 'transparent',
    border: 'none',
    borderRadius: 50,
    fontWeight: 400,
    fontSize: '16px',
    cursor: 'pointer',
    maxWidth: 180,
    maxHeight: 50,

    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      padding: '12px 8px',
      maxHeight: 40
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      padding: '12px 6px'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
      padding: '10px 4px'
    }
  },
  activeTabButton: {
    background: theme.palette.primary.contrastText,
    color: '#fff',
    fontWeight: 600,
    padding: 8,

    '&:hover': {
      background: theme.palette.primary.contrastText,
      color: '#fff'
    }
  }
}))
